export const CHART_COLORS = {
  WHITE: '#FFF',
  PINK: '#F25DA5',
  LIGHT_PINK: '#F59AC8',
  YELLOW: '#FCC434',
  BLUE: '#1E84E3',
  LIGHT_BLUE: '#70B5F5',
  TEAL: '#1BBFC2',
  BLACK: '#3B4056',
} as const
